
import React from 'react';
import FitnessLanding from '../components/FitnessLanding';
import './App.css';
import './index.css';

function App() {
  return (
    <div>
      <FitnessLanding />
    </div>
  );
}

export default App;
